// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__AMXiH","row":"ProcedureTreatmentSummary_row__1A7YX"};